import { render, staticRenderFns } from "./DynamicView.vue?vue&type=template&id=316dc33b"
import script from "./DynamicView.vue?vue&type=script&lang=js"
export * from "./DynamicView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports